import classNames from 'classnames';
import type { ReactNode } from 'react';
import type { CSSProperties } from 'styled-components';
import styled from 'styled-components';

import { Horizontal } from 'atoms/layout/flex';
import type { Color, HexColor, LinearGradient } from 'style/types';

const Root = styled.div`
  --triangle-size: var(--half-unit);
  margin-right: calc(-1 * var(--triangle-size));
  position: relative;
  cursor: pointer;
`;
const Content = styled(Horizontal).attrs({ gap: 0.5 })`
  background: var(--bg);
  padding: 2px 6px 2px var(--unit);
  color: var(--c-black);

  border-radius: 100px 40px 0px 100px;
  .left & {
    border-radius: 40px 100px 100px 0px;
  }
`;
const Triangle = styled.div`
  width: var(--triangle-size);
  height: var(--triangle-size);
  position: absolute;
  background: var(--bg);

  clip-path: polygon(100% 0, 0 0, 0 100%);
  right: 0;
  .left & {
    right: auto;
    left: 0;
    transform: scaleX(-1);
  }

  &:after {
    content: '';
    position: absolute;
    inset: 0;

    background-color: rgba(var(--c-rgb-black), 0.6);
  }
`;

export enum Position {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}
type Props = {
  color: Color | HexColor | LinearGradient;
  align?: Position;
  children: ReactNode;
};
export const CornerBadge = ({
  color,
  align = Position.RIGHT,
  children,
}: Props) => {
  return (
    <Root
      className={classNames({ left: align === Position.LEFT })}
      style={{ '--bg': color } as CSSProperties}
    >
      <Content gap={0.5}>{children}</Content>
      <Triangle />
    </Root>
  );
};
